(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["soap-fragrance-picker"] && !Shopify.designMode) return;
  try {
    (function(){
    var dialog=document.getElementById('mp-fragrance-dialog');
    if(!dialog||dialog.dataset.mpInit==='true')return;
    dialog.dataset.mpInit='true';
    var cards=Array.prototype.slice.call(dialog.querySelectorAll('[data-mp-soap]'));
    var regularSection=dialog.querySelector('[data-mp-regular-section]');
    var promoSection=dialog.querySelector('[data-mp-promo-section]');
    var accessorySection=dialog.querySelector('[data-mp-accessory-section]');
    var scrollArea=dialog.querySelector('.mp-dialog__scroll');
    var progressPanel=dialog.querySelector('.mp-progress-panel');
    var progressLabel=dialog.querySelector('[data-mp-progress-label]');
    var progressFill=dialog.querySelector('[data-mp-progress-fill]');
    var progressMessage=dialog.querySelector('[data-mp-progress-message]');
    var topTotal=dialog.querySelector('[data-mp-top-total]');
    var summaryTotal=dialog.querySelector('[data-mp-summary-total]');
    var selectionCountBox=dialog.querySelector('[data-mp-selection-count]');
    var feedback=dialog.querySelector('[data-mp-feedback]');
    var addBtn=dialog.querySelector('[data-mp-add-stay]');
    var checkoutBtn=dialog.querySelector('[data-mp-checkout]');
    var closeBtn=dialog.querySelector('[data-mp-close]');
    var stickyBar=document.querySelector('[data-mp-sticky]');
    var entry=document.querySelector('[data-mp-entry]');
    var nativeAddBtn=document.querySelector('[data-mp-native-add]');
    var formWrapper=document.querySelector('product-form');
    var mainForm=formWrapper?formWrapper.querySelector('form'):document.querySelector('form[action*="/cart/add"]');
    var state={};
    var cartOtherCount=0;
    var cartOtherOriginal=0;
    var wasUnlocked=false;
    var entryPassed=false;

    cards.forEach(function(card){
      var id=card.dataset.variantId;
      var cartQty=Number(card.dataset.cartQty)||0;
      var effectivePrice=Math.round((Number(card.dataset.priceCents)||0)/100);
      var originalPrice=Math.round((Number(card.dataset.compareAtCents)||Number(card.dataset.priceCents)||0)/100);
      state[id]={selected:cartQty,saved:cartQty,cartBase:cartQty,eligible:card.dataset.eligible==='true',price:effectivePrice,originalPrice:originalPrice};
    });
    var representedCount=0;
    var representedOriginal=0;
    Object.keys(state).forEach(function(id){representedCount+=state[id].cartBase;representedOriginal+=state[id].cartBase*state[id].originalPrice;});
    cartOtherCount=Math.max(0,(Number(dialog.dataset.cartItemCount)||0)-representedCount);
    cartOtherOriginal=Math.max(0,Math.round((Number(dialog.dataset.cartOriginalTotalCents)||0)/100)-representedOriginal);
    function money(value){return '$'+String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g,'.')+' COP';}
    function selectedCount(){var n=0;Object.keys(state).forEach(function(id){n+=state[id].selected;});return n;}
    function eligibleCount(){var n=0;Object.keys(state).forEach(function(id){if(state[id].eligible)n+=state[id].selected;});return n;}
    function hasChanges(){return Object.keys(state).some(function(id){return state[id].selected!==state[id].saved;});}
    function intendedModel(){
      var eligible=eligibleCount();
      var unlocked=eligible>=5;
      var total=cartOtherOriginal;
      Object.keys(state).forEach(function(id){var item=state[id];total+=item.selected*(item.eligible&&unlocked?20000:item.price);});
      return{eligible:eligible,unlocked:unlocked,total:total,missing:Math.max(0,120000-total),count:cartOtherCount+selectedCount()};
    }
    function model(){return intendedModel();}
    function render(){
      var m=model();
      cards.forEach(function(card){
        var item=state[card.dataset.variantId];
        card.querySelector('[data-mp-qty]').textContent=item.selected;
        card.classList.toggle('is-selected',item.selected>0);
        card.querySelector('[data-mp-selected-badge]').hidden=item.selected===0;
        var priceBox=card.querySelector('[data-mp-card-price]');
        if(priceBox)priceBox.innerHTML=m.unlocked?'<s>'+money(item.price)+'</s> <strong class="mp-price-special">'+money(20000)+'</strong>':money(item.price);
        card.querySelector('[data-mp-minus]').disabled=item.selected===0;
        card.querySelector('[data-mp-plus]').disabled=card.dataset.available==='false';
      });
      progressLabel.textContent=m.eligible<5?m.eligible+'/5':m.eligible+' jabones';
      progressFill.style.width=Math.min(100,(m.eligible/5)*100)+'%';
      topTotal.textContent='Total estimado: '+money(m.total);
      summaryTotal.textContent=money(m.total);
      selectionCountBox.textContent=m.count+' producto'+(m.count===1?'':'s');
      progressPanel.classList.toggle('is-unlocked',m.unlocked);
      if(!m.unlocked){
        var left=5-m.eligible;
        progressMessage.textContent=left===1?'¡Ya casi! Añade 1 más para activar la oferta':'Te faltan '+left+' para activar la oferta';
        promoSection.hidden=true;accessorySection.hidden=true;
      }else{
        promoSection.hidden=false;accessorySection.hidden=false;
        if(m.missing===0)progressMessage.innerHTML='<span>¡Felicidades! Disfrutas del precio especial y del envío gratis.</span>';
        else progressMessage.innerHTML='<span>¡Felicidades! Precio especial activado.</span>';
        if(!wasUnlocked){regularSection.parentNode.insertBefore(promoSection,regularSection);regularSection.parentNode.insertBefore(accessorySection,regularSection);requestAnimationFrame(function(){scrollArea.scrollTop=0;});}
      }
      wasUnlocked=m.unlocked;
      addBtn.disabled=!hasChanges();
      if(!hasChanges())addBtn.textContent=m.count>0?'Carrito actualizado ✓':'Añadir al carrito';
      else{
        var editingExisting=cartOtherCount>0||Object.keys(state).some(function(id){return state[id].saved>0;});
        addBtn.textContent=(editingExisting?'Actualizar carrito · ':'Añadir '+m.count+' · ')+money(m.total);
      }
      checkoutBtn.disabled=m.count===0&&Number(dialog.dataset.cartItemCount||0)===0;
    }
    cards.forEach(function(card){
      var id=card.dataset.variantId;
      card.querySelector('[data-mp-plus]').addEventListener('click',function(){state[id].selected+=1;feedback.textContent='';render();});
      card.querySelector('[data-mp-minus]').addEventListener('click',function(){state[id].selected=Math.max(0,state[id].selected-1);feedback.textContent='';render();});
    });
    function cartSnapshot(){return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(response){if(!response.ok)throw new Error('cart_read');return response.json();});}
    function syncFromCart(cart){
      var quantities={};
      (cart.items||[]).forEach(function(line){var id=String(line.variant_id);quantities[id]=(quantities[id]||0)+Number(line.quantity||0);});
      Object.keys(state).forEach(function(id){state[id].selected=quantities[id]||0;state[id].saved=state[id].selected;state[id].cartBase=state[id].selected;});
      var representedQty=selectedCount();
      var representedPrice=0;
      Object.keys(state).forEach(function(id){representedPrice+=state[id].selected*state[id].originalPrice;});
      cartOtherCount=Math.max(0,Number(cart.item_count||0)-representedQty);
      cartOtherOriginal=Math.max(0,Math.round(Number(cart.original_total_price||0)/100)-representedPrice);
      dialog.dataset.cartItemCount=cart.item_count||0;
    }
    function validateQuantities(cart){
      var quantities={};
      (cart.items||[]).forEach(function(line){var id=String(line.variant_id);quantities[id]=(quantities[id]||0)+Number(line.quantity||0);});
      var quantityMismatch=Object.keys(state).some(function(id){return (quantities[id]||0)!==state[id].selected;});
      var expected=intendedModel();
      if(quantityMismatch||Number(cart.item_count||0)!==expected.count){var quantityError=new Error('quantity_mismatch');quantityError.userMessage='No pudimos confirmar las cantidades. Tu carrito no fue enviado al pago.';throw quantityError;}
      return cart;
    }
    function saveSelection(){
      if(!hasChanges())return cartSnapshot();
      var updates={};
      Object.keys(state).forEach(function(id){if(state[id].selected!==state[id].saved)updates[id]=state[id].selected;});
      addBtn.disabled=true;checkoutBtn.disabled=true;feedback.textContent='Guardando…';
      return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates:updates})})
        .then(function(response){if(!response.ok)throw new Error('cart');return response.json();})
        .then(function(cart){
          validateQuantities(cart);
          syncFromCart(cart);
          document.dispatchEvent(new CustomEvent('cart:refresh'));document.dispatchEvent(new CustomEvent('cart:updated'));
          feedback.textContent='Añadido al carrito ✓';render();
          return cart;
        });
    }
    addBtn.addEventListener('click',function(){saveSelection().catch(function(){feedback.textContent='No pudimos actualizar el carrito.';render();});});
    checkoutBtn.addEventListener('click',function(){feedback.textContent='Verificando cantidades…';saveSelection().then(validateQuantities).then(function(){window.location.href='/checkout';}).catch(function(error){feedback.textContent=error&&error.userMessage?error.userMessage:'No pudimos preparar el pago.';render();});});
    function openDialog(){if(typeof dialog.showModal==='function')dialog.showModal();else dialog.setAttribute('open','');scrollArea.scrollTop=0;render();}
    document.addEventListener('click',function(event){var button=event.target.closest('[data-mp-open-selector]');if(!button)return;event.preventDefault();openDialog();});
    closeBtn.addEventListener('click',function(){dialog.close();});
    dialog.addEventListener('click',function(event){if(event.target===dialog)dialog.close();});
    if(mainForm){
      var quantitySelector=mainForm.querySelector('quantity-selector');
      var quantitySlot=document.querySelector('[data-mp-qty-slot]');
      if(quantitySelector&&quantitySlot)quantitySlot.appendChild(quantitySelector);
      var nativeSubmit=mainForm.querySelector('button[type="submit"]');
      if(nativeSubmit){nativeSubmit.style.display='none';nativeAddBtn.addEventListener('click',function(){nativeSubmit.click();});}
    }
    if(entry&&stickyBar){var observer=new IntersectionObserver(function(entries){entries.forEach(function(item){entryPassed=!item.isIntersecting&&item.boundingClientRect.top<0;stickyBar.hidden=!entryPassed||dialog.open;});},{threshold:0});observer.observe(entry);}
    dialog.addEventListener('close',function(){if(stickyBar)stickyBar.hidden=!entryPassed;});
    render();
  })();
  } catch(e) { console.error(e); }
})();

})();
